import { useEffect, useState } from 'react';

export const useResponsive = () => {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width < 768;
  const isMobileOrTablet = width < 1024;
  const isDesktop = width >= 1024;

  return { isMobile, isMobileOrTablet, isDesktop };
};
